import { Link } from 'react-router-dom';
import Button from '../basic/Button';

const Toys = () => {
  return (
    <main>

      <section className="articles">

        <article>
          <h3>Tempo Finder</h3>
          <p>
            This will give you a tempo in beats per minute as you press the space bar, allowing you to easily find the bpm of a song, or to make one when making a new tune.
          </p>
          <Button to="/toys/tempo-finder" text="Go To Tempo Finder" icon_path="/images/icons/down-icon.svg" alt_text="Down Arrow" />
        </article>

        <article>
          <h3>Random Byte Generator</h3>
          <p>
            This will generate a pseudo-random string of 8 binary digits, 0s and 1s.
          </p>
          <Button to="/toys/random-byte-generator" text="Go To RBG" icon_path="/images/icons/down-icon.svg" alt_text="Down Arrow" />
        </article>

      </section>

    </main>
  );
}

export default Toys;